import { render, staticRenderFns } from "./ClearLocalStorage.vue?vue&type=template&id=853d5358"
import script from "./ClearLocalStorage.vue?vue&type=script&lang=ts"
export * from "./ClearLocalStorage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports